import React from 'react';
import type { HomeProps } from '../../../shells/types';

interface Tile {
  testId: string;
  glyph: string;
  title: string;
  sub: string;
  target: string;
  reason: string;
}

const TILES: Tile[] = [
  { testId: 'tiles-help-others', glyph: '🤝', title: 'Help others', sub: 'be a helper',    target: 'env-board',           reason: 'tiles-help-others' },
  { testId: 'tiles-calls',       glyph: '📞', title: 'Calls',       sub: 'voice + video',  target: 'env-voice',           reason: 'tiles-calls' },
  { testId: 'tiles-talk',        glyph: '💬', title: 'Talk',        sub: 'messages',       target: 'sass-chats',          reason: 'tiles-talk' },
  { testId: 'tiles-vote',        glyph: '✓', title: 'Vote',         sub: 'pending posts',  target: 'sass-prepublish-vote', reason: 'tiles-vote' },
  { testId: 'tiles-stuff',       glyph: '📦', title: 'Stuff',       sub: 'your vault',     target: 'env-vault',           reason: 'tiles-stuff' },
  { testId: 'tiles-news',        glyph: '📰', title: 'News',        sub: 'town headlines', target: 'news-paper',          reason: 'tiles-news' },
];

/**
 * Phase 73 full — Kids A · Helper Tiles Home surface.
 *
 * Big SOS bar + 2-column tile grid. No mascot persona. Calm, scannable,
 * works at arm's length on a tablet. Reskin only — every tile bridges
 * to an existing surface.
 */
export function TilesHome({ ctx }: HomeProps): JSX.Element {
  const go = (target: string, reason: string) => {
    ctx.director.bridge(target, reason);
  };

  return (
    <div className="tiles-home" data-testid="tiles-home">
      <div className="tiles-greeting">Hi! What do you want to do?</div>
      <div className="tiles-hint">Tap a big card to start.</div>

      <button
        type="button"
        className="tiles-sos"
        data-testid="tiles-sos"
        onClick={() => go('env-intake', 'tiles-sos')}
      >
        <span className="tiles-sos-glyph" aria-hidden>🚨</span>
        <span className="tiles-sos-text">
          <span className="tiles-sos-title">I need help</span>
          <span className="tiles-sos-sub">Tell a grown-up something happened.</span>
        </span>
      </button>

      <div className="tiles-grid">
        {TILES.map((t) => (
          <button
            key={t.testId}
            type="button"
            className="tile"
            data-testid={t.testId}
            onClick={() => go(t.target, t.reason)}
          >
            <span className="tile-glyph" aria-hidden>{t.glyph}</span>
            <span className="tile-title">{t.title}</span>
            <span className="tile-sub">{t.sub}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
